import { render, staticRenderFns } from "./critical-ratio-threshold-config.vue?vue&type=template&id=34a9018a&"
import script from "./critical-ratio-threshold-config.vue?vue&type=script&lang=js&"
export * from "./critical-ratio-threshold-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports